/**
* Copyright 2012-2019, Plotly, Inc.
* All rights reserved.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/
'use strict';

var heatmapCalc = require('../heatmap/calc');

var setContours = require('./set_contours'); // most is the same as heatmap calc, then adjust it
// though a few things inside heatmap calc still look for
// contour maps, because the makeBoundArray calls are too entangled


module.exports = function calc(gd, trace) {
  var cd = heatmapCalc(gd, trace);
  setContours(trace);
  return cd;
};